// src/plugins/notification.js
import Vue from 'vue';
import VueNotification from 'vue-notification';

Vue.use(VueNotification);

const NotificationPlugin = {
    install(Vue) {
        Vue.prototype.$toastr = {
            s(title, message) {
                Vue.notify({
                    // group: 'custom-template',
                    title: title || 'Success',
                    duration: 30*1000,
                    text: message || 'Operation completed successfully!',
                    type: 'success',
                });
            },
            e(title, message) {
                Vue.notify({
                    // group: 'custom-template',
                    title: title || 'Error',
                    duration: 30*1000,
                    text: message || 'An error occurred!',
                    type: 'danger',
                });
            },
        };
    },
};

export default NotificationPlugin;
